import React from 'react';
export function ProductInfo() {
  return <div className="max-w-3xl mx-auto px-4 py-4" data-id="element-112">
      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-113">
        The Water Additive Jennifer Showed Me
      </h2>

      <p className="mb-6" data-id="element-114">
        Jennifer pulled out her phone and showed me what she'd been using:
        Melao™ Dental Formula.
      </p>
      <p className="mb-6" data-id="element-115">
        She wasn't selling it. Didn't get a commission. Just knew it worked.
      </p>
      <p className="mb-6" data-id="element-116">
        "It breaks down biofilm from the inside out," she explained. "You just
        add a capful to their water bowl daily. Luna drinks normally, and the
        formula does the rest."
      </p>

      <p className="mb-6 font-bold" data-id="element-117">How it works:</p>

      <ul className="mb-6 space-y-2 ml-6" data-id="element-118">
        <li data-id="element-119">
          • Stabilized chlorine dioxide releases oxygen that kills bacteria and
          disrupts biofilm structure
        </li>
        <li data-id="element-120">
          • Sodium bicarbonate neutralizes acid and prevents new plaque
          formation
        </li>
        <li data-id="element-121">
          • Tetrasodium EDTA binds minerals before they harden into tartar
        </li>
      </ul>

      <p className="mb-6" data-id="element-122">Every time your dog drinks, it's working.</p>

      <p className="mb-6" data-id="element-123">No wrestling. No fighting. No guilt.</p>

      <p className="mb-6" data-id="element-124">
        I was skeptical. But desperate enough to try anything.
      </p>

      <div className="mt-8 mb-10 flex justify-center" data-id="element-125">
        <a href="https://hushpups.co/products/melao-dental-formula" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300" data-id="element-126">
          Learn More About Melao™
        </a>
      </div>

      <div className="my-8" data-id="element-127">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aC29dq3Np5Q8T5Mqp81hoP/MELAO_%285%29.png" alt="Melao Pet Dental Formula water additive bottle" className="w-full h-auto rounded-lg shadow-md" data-id="element-128" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-129">
          Simple water additive - just add to your dog's bowl daily
        </p>
      </div>

      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-130">
        My Results After Trying Melao
      </h2>

      <p className="mb-4" data-id="element-131">
        <span className="font-bold" data-id="element-132">Day 3:</span> Luna's breath didn't smell
        like a dumpster. First time in months.
      </p>
      <p className="mb-4" data-id="element-133">
        <span className="font-bold" data-id="element-134">Week 2:</span> I noticed she was drinking
        more water (maybe it actually tasted better?). The brown crud on her
        teeth looked... softer?
      </p>
      <p className="mb-4" data-id="element-135">
        <span className="font-bold" data-id="element-136">Week 4:</span> I was brushing her coat and
        she yawned. Her back teeth—the ones that were completely covered in
        tartar—had visible enamel showing through. The tartar was literally
        flaking off on its own.
      </p>
      <p className="mb-6" data-id="element-137">
        <span className="font-bold" data-id="element-138">Month 3:</span> I took her in for what I
        thought would be that $1,200 cleaning.
      </p>

      <p className="mb-6" data-id="element-139">
        My vet examined her mouth and looked genuinely confused.
      </p>
      <p className="mb-6 italic" data-id="element-140">
        "What have you been doing? Her gums look great. The tartar is minimal. I
        don't think she needs a cleaning."
      </p>

      <p className="mb-6" data-id="element-141">I almost cried in the exam room.</p>

      <p className="mb-6" data-id="element-142">No extraction. No anesthesia. No $1,200 bill.</p>

      <p className="mb-6" data-id="element-143">
        Just a $60 checkup and my vet asking what I'd been using.
      </p>

      <div className="my-8" data-id="element-144">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oZhcxFQsamMUoHnaLLQNux/MELAO_%2813%29.png" alt="Veterinarian examining happy healthy dog" className="w-full h-auto rounded-lg shadow-md" data-id="element-145" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-146">
          The vet visit that changed everything
        </p>
      </div>

      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-147">
        What Changed in Luna's Life
      </h2>

      <p className="mb-6 font-bold" data-id="element-148">
        Six months later, here's what's different:
      </p>

      <ul className="mb-6 space-y-2" data-id="element-149">
        <li className="flex items-start" data-id="element-150">
          <span className="text-green-600 mr-2" data-id="element-151">✓</span>
          <span data-id="element-152">
            Breath is 90% better – I don't turn away when she tries to lick my
            face anymore
          </span>
        </li>
        <li className="flex items-start" data-id="element-153">
          <span className="text-green-600 mr-2" data-id="element-154">✓</span>
          <span data-id="element-155">
            Tartar barely forms – her teeth stay clean between vet visits
          </span>
        </li>
        <li className="flex items-start" data-id="element-156">
          <span className="text-green-600 mr-2" data-id="element-157">✓</span>
          <span data-id="element-158">Gums are pink and healthy – no more bleeding</span>
        </li>
        <li className="flex items-start" data-id="element-159">
          <span className="text-green-600 mr-2" data-id="element-160">✓</span>
          <span data-id="element-161">
            More energy – she plays longer, eats with enthusiasm again
          </span>
        </li>
        <li className="flex items-start" data-id="element-162">
          <span className="text-green-600 mr-2" data-id="element-163">✓</span>
          <span data-id="element-164">
            No more guilt – I'm actually protecting her teeth instead of failing
            at brushing
          </span>
        </li>
      </ul>

      <p className="mb-6" data-id="element-165">
        My husband noticed before I did: "She's acting like a puppy again. What
        changed?"
      </p>
      <p className="mb-6" data-id="element-166">
        What changed was I stopped fighting a battle I couldn't win—and started
        disrupting the biofilm that was causing all the problems.
      </p>

      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-167">
        If You're Tired of Feeling Like You're Failing Your Dog...
      </h2>

      <p className="mb-6" data-id="element-168">If you've tried brushing and can't keep up...</p>
      <p className="mb-6" data-id="element-169">If dental chews aren't working...</p>
      <p className="mb-6" data-id="element-170">If you're dreading the next $1,000 vet bill...</p>
      <p className="mb-6" data-id="element-171">Melao™ Dental Formula might be worth trying.</p>
      <p className="mb-6" data-id="element-172">It's not a breath mint. It's not a temporary fix.</p>
      <p className="mb-6" data-id="element-173">
        It's a formula that breaks down the bacterial shield protecting the
        plaque, tartar, and infection in your dog's mouth.
      </p>
      <p className="mb-6" data-id="element-174">One capful in their water bowl daily. That's it.</p>
      <p className="mb-6" data-id="element-175">The company explains exactly how it works here:</p>
    </div>;
}